<template>
    <div>
        <el-link @click="canvasMap">{{ title }}</el-link>
        <el-dialog
            custom-class="mapDialog"
            title="地图"
            :visible.sync="mapShow"
            append-to-body
            width="70%">
            <div>
                <el-row :gutter="10">
                    <el-col :span="6" v-for="(item,index) in tableData" :key="index">
                        <div class="empty" style="position: relative">
                             <el-image style="height: 200px" :src="item.fileUrl" :preview-src-list="[item.fileUrl]" fit=""></el-image>
                            <div style="background-color: rgba(0,0,0,0.7);position: absolute;padding: 5px;top: 0;right: 0">
                                <el-tag v-if="item.show === 1" type="success" style="margin-right: 5px" size="mini">已选取</el-tag>
                                <el-button v-if="item.show === 0" type="success" size="mini" @click="selectionMap(item)">选取</el-button>
                                <el-button type="danger" size="mini" @click="deleteMap(item)">删除</el-button>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="empty">
                            <div style="display: flex;flex-direction: column;align-items: center">
                                <i @click="getMap" style="font-size: 80px;" class="el-icon-plus ssss"></i>
                                <span style="font-size: 18px;margin-top: 5px">点击“+”号可截取地图</span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>

        </el-dialog>
        <planMap class="planMapOp" @closeDialog="closeDialog" ref="planMapShow" @allowExport="allowExport"></planMap>
    </div>
</template>
<script>
import planMap from "@/views/plan/leftMoudle/dialog/planMap.vue";
import PlanApi from "@/components/Api/PlanApi";
import {mapState} from "vuex";

export default {
    data() {
        return {
            mapShow: false,
            tableData: []
        }
    },
    components: {planMap},
    computed: {
        ...mapState(['planId']),
        ...mapState(['budgetMainId'])
    },
    props: {
        title: {
            type: String,
            default: () => {
                return "点击此处生成地图行程>>"
            }
        }
    },
    methods: {
        selectionMap(map) {
            new PlanApi("plan").selectMap(map.id,this.budgetMainId).then(res => {
                if (res.status === 200) {
                    this.$message.success("选取成功！")
                    this.load()
                }
            })
        },
        deleteMap(map) {
            new PlanApi("plan").mapDeleteMapById(map.id).then(res => {
                if (res.status === 200) {
                    this.$message.success("删除成功！")
                    this.load()
                }
            })
        },
        getMap() {
            this.$refs.planMapShow.init()
        },
        canvasMap() {
            this.mapShow = true
            this.load()
            // setTimeout(() => {
            //     this.$refs.planMapShow.init()
            // },1000)
        },
        closeDialog() {
        },
        allowExport() {
            this.$refs.planMapShow.close()
            this.load()
        },
        load() {
            new PlanApi("plan").mapList(this.budgetMainId).then(res => {
                if (res.status === 200) {
                    this.tableData = res.data
                    console.log("this.tableData",res)
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.el-dialog__wrapper {
    z-index: 9999 !important;
}

:deep(.el-dialog__body) {
    min-height: 500px;
    background-color: rgba(101, 44, 23, 0.1);
    padding: 10px;
    padding-top: 10px !important;

    .empty {
        height: 200px;
        //width: 200px;
        background-color: rgba(101, 44, 23, 0.3);
        border-radius: 10px;
        margin-bottom: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        .ssss {
            &:hover {
                cursor: pointer;
            }
        }
    }
}
</style>